export class ConfiguratorFieldDepencencyController {
    constructor() {
         this.fields = [];
    }

    createDepdencyMap(){
        var fields = this.fields;
        fields.forEach((field) => {
            const fieldsDependsOnMe = fields.filter(x => x.DependentControlId === field.Id);
            field.dependency = {
                ...field.dependency, 
                fieldsDependsOnMe: fieldsDependsOnMe
            }
            
            if(field.dependency.fieldsDependsOnMe && field.dependency.fieldsDependsOnMe.length > 0 && field.dependency.handleDependencies){
                field.dependency.handleDependencies();
            }
        });
    }
    
    
    setDependencyOnField({ field, htmlInput, controlToHide, that, triggerOnEvent, getValueCallback, onVisiblityChange }){
        let thisRef;
        if (that) {
            thisRef = that;
            that.fields.push(field);
        } else {
            thisRef = this;
            this.fields.push(field);
        }
        function doHandle(){
            const newValue = getValueCallback(field); 
            
            if(field.dependency.fieldsDependsOnMe){
                field.dependency.fieldsDependsOnMe.forEach((depField) => {              
                    
                    let hide = false;
                    if (Array.isArray(newValue)) {
                        hide = newValue.indexOf(depField.DependentControlValue) > -1;
                    } else {         
                        hide = newValue == depField.DependentControlValue;
                    }
            
                    if(hide){
                        if(depField.dependency.hidden != false){
                            depField.dependency.controlToHide.style.display = "block"
                            depField.dependency.hidden = false;        
                            if(onVisiblityChange) 
                                onVisiblityChange(depField, false, thisRef.configuratorRef);
                        }
                                
                    }else{
                        if(depField.dependency.hidden != true){
                            depField.dependency.controlToHide.style.display = "none"
                            depField.dependency.hidden = true;     
                            if(onVisiblityChange) 
                                onVisiblityChange(depField, true, thisRef.configuratorRef);
                        }
                    }
                })
            }
        }

        let onEventMethod = (e) => {
            if(getValueCallback) {
                doHandle();
            }
        }

        if (Array.isArray(htmlInput)) {
            htmlInput.forEach((input) => {
                input.addEventListener(triggerOnEvent, onEventMethod);
            });
        } else {         
            htmlInput.addEventListener(triggerOnEvent, onEventMethod);
        }

        field.dependency = {
            ...field.dependency, 
            controlToHide: controlToHide,
            handleDependencies: doHandle,
            hidden: false
        }  
    }
}
